module.exports = __webpack_public_path__ + "static/media/hotel-12.9e2273ad.jpg";